<template>
  <Content
    class="col-span-full"
    :title="$route.name"
    :showAdd="false"
    :pagination="{
      count: tableData.count,
      current: +$route.query.p,
      request: `geofences/events/`,
    }"
    @tableData="tableData = $event"
    @loading="loading = $event"
  >
    <ruleTable
      :tableData="tableData"
      :alpha="alphaList"
      :type="activeName"
      :loading="loading"
    />
  </Content>
</template>

<script>
import { FenceEvents } from '@/api/reports'
import ruleTable from '@/components/reports/ruleTable'
import { licenseChars } from '@/api/global'

export default {
  data() {
    return {
      tableData: {
        results: [],
      },
      alphaList: [
        {
          char: '',
          code: '',
        },
      ],

      search: '',
      loading: true,
      activeName: 'speeds',
    }
  },

  mounted() {
    FenceEvents.api().then((res) => {
      if (res) {
        this.tableData = res
      }
      this.loading = false
    })
    licenseChars.api().then((res) => {
      this.alphaList = res
    })
  },
  components: {
    ruleTable,
  },
}
</script>
